import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  Image,
  PDFDownloadLink,
} from "@react-pdf/renderer";

const NewTechCardInfo = ({ techData }) => {
  return (
    <View>
      <View
        style={{
          fontSize: "8px",
          border: "2px solid black",
          marginTop: "10px",
          paddingHorizontal: "5px",
        }}
      >
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            borderBottom: "1px solid black",
          }}
        >
          <Text style={{ width: "50%" }}>Sachbearbeiter Kunde</Text>
          <Text style={{ width: "20%" }}>Tel. Kunde</Text>
          <Text style={{ width: "30%" }}>E-Mail Kunde</Text>
          <Text style={{ width: "50%" }}>
            {techData.customer.representative}
          </Text>
          <Text style={{ width: "20%" }}>{techData.customer.phone}</Text>
          <Text style={{ width: "30%" }}>{techData.customer.email}</Text>
        </View>
        <View
          style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
        >
          <Text style={{ width: "50%" }}>Sachbearbeiter Prolux</Text>
          <Text style={{ width: "20%" }}>Tel. Prolux</Text>
          <Text style={{ width: "30%" }}>E-Mail Prolux</Text>
          <Text style={{ width: "50%" }}>{techData.user}</Text>
          <Text style={{ width: "20%" }}>+41 71 447 48 48</Text>
          <Text style={{ width: "30%" }}>info@prolux-ag.ch</Text>
        </View>
      </View>

      <View
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          fontSize: "8px",
          border: "2px solid black",
          marginTop: "10px",
          paddingHorizontal: "5px",
        }}
      >
        <View
          style={{
            width: "50%",
            textAlign: "center",
            borderRight: "1px solid black",
          }}
        >
          <Text>Max. Gesamtabmessungen Gerät (Höhe x Breite x Länge)</Text>
          <Text>
            gem. Skizze/{" "}
            {techData.generalProductSpec.height +
              " x " +
              techData.generalProductSpec.width +
              " x " +
              techData.generalProductSpec.length}{" "}
            mm
          </Text>
        </View>
        <View
          style={{
            width: "15%",
            textAlign: "center",
            borderRight: "1px solid black",
          }}
        >
          <Text>Gesamtgewicht</Text>
          <Text> {techData.generalProductSpec.weight} kg</Text>
        </View>
        <View
          style={{
            width: "15%",
            textAlign: "center",
            borderRight: "1px solid black",
          }}
        >
          <Text>Aufstellung</Text>
          <Text>
            {techData.calculation.euroventCalculation.altitude} m.ü.M.
          </Text>
        </View>
        <View style={{ width: "20%", textAlign: "center" }}>
          <Text>Umgebungsdruck</Text>
          <Text>101325 mbar</Text>
        </View>
      </View>
    </View>
  );
};

export default NewTechCardInfo;
